import React, { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import useWarehouseOrderExpeditionService from '../../../app/services/hooks/useWareHouseOrderExpedition';
import { WarehouseOrderExpeditionDataForm } from '../../../app/models/WareHouseOrderExpedition';
import { Place } from '../../../app/models/Place';
import { Depot } from '../../../app/models/Depot';
import { RouteSegment } from '../../../app/models/RouteSegment';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import { PackingType } from '../../../app/models/PackingType';
import { AppContext } from '../../../contexts/AppContext';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import WarehouseOrderExpeditionForm from './forms/WareHouseOrderExpeditionForms/WareHouseOrderExpeditionForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { ExpeditionOptions } from '../../../app/models/ExpeditionOptions';



interface Props {
    warehouseOrderId: number;
    onSaved: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseOrderExpeditionCreate = ({ warehouseOrderId, onSaved, onCancel, onError }: Props) => {
    const {
        createWarehouseOrderExpedition,
        storeWarehouseOrderExpedition,
        showExpeditionWarehouseOrderExpedition,
        fetchingCreateWarehouseOrderExpedition
    } = useWarehouseOrderExpeditionService();

    const [form, setForm] = useState<WarehouseOrderExpeditionDataForm>({
        warehouse_order_id: warehouseOrderId,
        place_id: 0,
        // destination_id: 0,
        depot_id: 0,
        route_segment_id: 0,
        unit_id: 0,
        currency_id: 0,
        rate: 0,
        expeditions_option_id: 0,
    });

    const [origins, setOrigins] = useState<Place[]>([]);
    const [destinations, setDestinations] = useState<Place[]>([]);
    const [depots, setDepots] = useState<Depot[]>([]);
    const [routeSegments, setRouteSegments] = useState<RouteSegment[]>([]);
    const [expetionsOptions, setExpetionsOptions] = useState<ExpeditionOptions[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [packingTypes, setPackingTypes] = useState<PackingType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const { hideLoading, showLoading } = useContext(AppContext);
    const warehouseOrderExpeditionFromQwe = useRef<WarehouseOrderExpeditionDataForm|undefined>();

    const create = () => {
        createWarehouseOrderExpedition(warehouseOrderId, {
            onSuccess: (response: ServiceResponse) => {
                setOrigins(response.data.origins);
                setDestinations(response.data.destinations);
                setDepots(response.data.depots);
                setRouteSegments(response.data.route_segments);
                setCurrencies(response.data.currencies);
                setUnits(response.data.units);
                setPackingTypes(response.data.packing_types);
                setExpetionsOptions(response.data.expetions_options)
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                onError && onError();
            }
        });
    };

    useEffect(() => {
        create();
    }, []);

    useEffect(() => {
        if (form.expeditions_option_id) {
            showExpeditionWarehouseOrderExpedition(form.expeditions_option_id, {
                onSuccess: (response: ServiceResponse) => {
                    setErrorFields(undefined);
                    setForm({
                        ...form,
                        ...response.data.expetions
                    });

                },
                onError: (response: ServiceResponse) => {
                    setForm({
                        ...form,
                    });
                }
            });
        }
    }, [form.expeditions_option_id]);


    const store = () => {
        storeWarehouseOrderExpedition(form, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },

            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    if (fetchingCreateWarehouseOrderExpedition) {
        return <p>Cargando datos de expedición…</p>;
    }

    return (
        <>
            <WarehouseOrderExpeditionForm
                expeditionDataForm={form}
                setExpeditionDataForm={setForm}
                origins={origins}
                destinations={destinations}
                depots={depots}
                routeSegments={routeSegments}
                currencies={currencies}
                units={units}
                packingTypes={packingTypes}
                expeditionOptions={expetionsOptions}
                errorFields={errorFields}
                disableUpdate={true}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} />
                </div>
            </div>
        </>
    );
};

export default WarehouseOrderExpeditionCreate;
